
<div class="row">
    <div class="col-md-12">
        <br>
        <div [hidden]="resultados">

            <button type="button" class="col-md-1 btn btn-rounded-xs btn-rounded btn-dark m-b-10" (click)="RegresarFromulario()"
                style="color: white;"><i class="fas fa-angle-double-left"></i> Atrás </button>



            <div class="btn-group" ngbDropdown container="body" role="group"
                aria-label="Button group with nested dropdown">
                <button class="btn btn-rounded btn-info m-b-10" ngbDropdownToggle>
                    <i class="fas fa-file-pdf"></i> Imprimir
                </button>
                <div class="dropdown-menu" ngbDropdownMenu>
                    <button class="dropdown-item" (click)="ImprimirEstadoCuenta()"><i class="fas fa-copy font-14"
                            style="margin-right: .3rem"></i>
                        Imprimir estado de cuenta</button>
                    <!--<button class="dropdown-item" (click)="ImprimirEECC(2)"><i class="fas fa-copy font-14"
                            style="margin-right: .3rem"></i>
                        Pendientes con representante legal</button>-->
                </div>

            </div>
            <button type="button" class="close" aria-label="Close" (click)="cerrar()" >
                <span aria-hidden="true">&times;</span>
            </button>

        </div>

        <div [hidden]="!resultados" class="col-md-12" style="margin-left: 2px;">
            <div [hidden]="false">
                <button type="button" class="btn btn-rounded btn-info m-b-10" (click)="consultar()"><i
                        class="fa fa-search"></i>
                    Buscar </button>
                <button type="button" class="close" aria-label="Close" (click)="cerrar()" >
                        <span aria-hidden="true">&times;</span>
                    </button>
            </div>
        </div>

        <div class="card">
            <div class="card-header" style="background-color: white;height: 53px;">
                <div class="form-inline">
                    <label class="form-control-label-sm mr-3" style="font-weight:bold">Consulta estado de cuentas proveedor - {{intelocutorSeleccionado}}
                    </label>
                </div>
            </div>

            <div [hidden]="!resultados" class="card-body" style="border-top: 2px solid rgb(145, 145, 148) !important;">
                <div class="row">
                    <div class="col-md-6">

                        <label for="fname2" class="text-left control-label col-form-label">Interlocutor Comercial:
                        </label>
                        <div class="form-group row" style="margin-bottom: 0px;">

                            <div class="col-sm-4">
                                <input id="inputinterlocutorcodigo" type="text"
                                    class="form-control form-control-sm text-left" name="desInterlocutor"
                                    [(ngModel)]="codInterlocutor" [disabled]="disabledInterlocutor" tabindex="5"
                                    (keydown.enter)="onKeyEnterCodInterlocutor($event,codInterlocutor)" #interlocutor
                                    placeholder="-1">
                            </div>
                            <div class="col-sm-7" style="padding-right: 0px;">

                                <input id="inputinterlocutornombre" type="text"
                                    class="form-control form-control-sm text-left" name="desInterlocutor"
                                    [(ngModel)]="desInterlocutor" [disabled]="disabledInterlocutor" tabindex="6" #razon
                                    (keydown.enter)="onKeyEnterInterlocutor($event)" placeholder="Todos">


                            </div>
                            <div class="input-group-btn">
                                <button *ngIf="buscarInterlocutor == 'buscar' "
                                    class="btn btn-primary btn-sm boton m-b-5" (click)="openModalInterlocutor()"
                                    type="button" tabindex="7"><i class="fa fa-search"></i></button>
                                <button *ngIf="buscarInterlocutor == 'borrar'"
                                    class="btn btn-primary btn-sm boton m-b-5" (click)="borrarDatosInterlocutor()"
                                    type="button" tabindex="7"><i class="fas fa-times"></i></button>
                            </div>
                            <span style="color: red; font: sans-serif;">(*)</span>
                        </div>


                        <label for="fname2" class="text-left control-label col-form-label">Observación:
                        </label>
                        <div class="form-group row" style="margin-bottom: 0px;">
                            <div class="col-sm-12">
                                <textarea class="form-control form-control-sm input_border" style="font-weight: bold"
                                    rows="3" [(ngModel)]="castobserv" name="castobserv" readonly></textarea>
                            </div>
                        </div>

                        <label class="text-left control-label col-form-label">Filtrar por</label>
                        <div class="form-row" style="margin-bottom: 0px;">
                            <div class="col-md-12">
                                <label class="ui-radio ui-radio-inline">
                                    <input type="radio" (change)="onChangeFiltroDocument($event.target.value)" value="N"
                                        [(ngModel)]="radioValue" name="radioValue" checked>
                                    <span class="input-span"></span>Todos los documentos</label>
                            </div>
                            <div class="col-md-12">

                                <label class="ui-radio ui-radio-inline">
                                    <input type="radio" value="S" (change)="onChangeFiltroDocument($event.target.value)"
                                        [(ngModel)]="radioValue" name="radioValue">
                                    <span class="input-span"></span>Documentos pendientes</label>
                            </div>
                            <!--<div class="col-md-12" style="margin-top: 1.5rem">
                                <label class="ui-checkbox ui-checkbox-inline">
                                    <input type="checkbox" type="checkbox" [(ngModel)]="checkboxValue"
                                        name="checkboxValue" (change)="onChange($event.target.checked)">
                                    <span class="input-span"></span>Incluye documentos descontados</label>
                            </div>-->
                        </div>

                    </div>

                    <div class="col-md-6">


                        <div class="form-row" style="margin-bottom: 0px;">
                            <label class="col-md-3 text-left control-label col-form-label">Línea
                                crédito</label>
                            <div class="col-md-3">
                                <input class="form-control form-control-sm" [(ngModel)]="simbolo" name="simbolo"
                                    type="text" disabled>
                            </div>
                            <div class="col-md-6">
                                <input class="form-control form-control-sm" value="{{limcre2 | number:'.2-2' }}"
                                    name="limcre2" type="text" disabled>
                            </div>
                        </div>

                        <div class="form-row" style="margin-bottom: 0px;">
                            <label class="col-md-3 text-left control-label col-form-label">Disponible</label>
                            <div class="col-md-3">
                                <input class="form-control form-control-sm" [(ngModel)]="simbolo" name="simbolo"
                                    type="text" disabled>
                            </div>
                            <div class="col-md-6">
                                <input class="form-control form-control-sm" value="{{limcredis2 | number:'.2-2' }}"
                                    name="limcredis2" type="text" disabled>
                            </div>
                        </div>

                        <div class="form-row" style="margin-bottom: 0px;">
                            <label class="col-md-3 text-left control-label col-form-label">Forma de
                                pago</label>
                            <div class="col-md-3">
                                <input class="form-control form-control-sm" type="text" disabled [(ngModel)]="codpag2"
                                    name="codpag2">
                            </div>
                            <div class="col-md-6">
                                <input class="form-control form-control-sm" style="font-weight: bold" type="text"
                                    disabled [(ngModel)]="despag2" name="despag2">
                            </div>
                        </div>
                        <!--<div class="form-row" style="margin-bottom: 0px;">
                            <label class="col-md-3 text-left control-label col-form-label">Fidelidad</label>
                            <div class="col-md-9">
                                <input class="form-control form-control-sm" style="font-weight: bold" type="text"
                                    disabled [(ngModel)]="desfidelidad" name="desfidelidad">
                            </div>
                        </div>-->

                        <!--<div class="form-row" style="margin-bottom: 0px;">
                            <label class="col-md-3 text-left control-label col-form-label">Ubicación</label>

                            <div class="col-md-9">
                                <select name="_ubicacion" [(ngModel)]="_ubicacion" id="_ubicacion"
                                    class="form-control form-control form-control-sm" tabindex="4">
                                    <option *ngFor="let suc of ubicaciones" value="{{suc.codubi}}">{{suc.desubi}}
                                    </option>
                                </select>
                            </div>
                        </div>-->





                    </div>
                </div>

            </div>

            <div [hidden]="resultados" class="card-body" style="border-top: 2px solid rgb(145, 145, 148) !important;">

                <!--
                    <div class="input-group" *ngIf="cotizacionSeleccionada">
                        <div class="btn-group mr-3" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                            <button class="btn btn-outline-primary" ngbDropdownToggle>
                                <i class="fas fa-bars mr-2"></i> Opciones
                            </button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                                <button class="dropdown-item" (click)="trazabilidad(cotizacionChecada)"><i
                                        class="fas fa-copy font-14" style="margin-right: .3rem"></i>
                                    Trazabilidad</button>
                            </div>
                        </div>
                        <div>
                            <span>Documento seleccionado : {{cotizacionChecada.numint}}</span>
                        </div>
                    </div>
                -->


                <br>
                <div class="input-group justify-content-end">
                <input type="text" placeholder="Buscar ..." class="form-control col-md-6" (keydown)="onChange2($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm">
                </div>

                <ngb-tabset>
                    <ngb-tab>
                        <ng-template ngbTabTitle> <span>Datos generales</span> </ng-template>
                        <ng-template ngbTabContent>
                            <br>
                            <div class="table-responsive" style="height: 65vh;">
                                <table id="general" class="table table-sm table-striped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                            <th style="white-space: nowrap"> Tipo</th>
                                            <th style="white-space: nowrap"> Docu</th>
                                            <th style="white-space: nowrap"> T.C</th>
                                            <th style="white-space: nowrap"> Abrevi. </th>
                                            <th style="white-space: nowrap"> Comprobante </th>
                                            <th style="white-space: nowrap"> Referencia </th>
                                            <th style="white-space: nowrap"> Referencia 2 </th>
                                            <th style="white-space: nowrap"> Operación </th>
                                            <th style="white-space: nowrap"> F.Emisión </th>
                                            <th style="white-space: nowrap"> F.Vencimiento </th>
                                            <th style="white-space: nowrap"> F.Cancelación </th>
                                            <th style="white-space: nowrap"> Dias Mora </th>
                                            <th style="white-space: nowrap"> Moneda </th>
                                            <th style="white-space: nowrap"> Importe original </th>
                                            <th style="white-space: nowrap"> Debe </th>
                                            <th style="white-space: nowrap"> Haber </th>
                                            <th style="white-space: nowrap"> Saldo </th>
                                            <th style="white-space: nowrap"> Planilla </th>
                                            <th style="white-space: nowrap"> Descripción </th>
                                            <th style="white-space: nowrap"> Planilla-Letra(s) </th>
                                            <th style="white-space: nowrap"> Banco </th>
                                            <th style="white-space: nowrap"> #Banco </th>
                                            <th style="white-space: nowrap"> Operación </th>
                                            <th style="white-space: nowrap"> Tcambio </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let est of estadocuenta" (click)="onClick(est)"
                                            [ngClass]="{'nombre-de-la-clase': est == this.esttemp}">
                                            <td style="text-align: center;">

                                                <div class="btn-group dropright" ngbDropdown container="body"
                                                    role="group" aria-label="Button group with nested dropdown"
                                                    style="margin: 0px; padding: 0px;">
                                                    <button class="btn btn-sm" ngbDropdownToggle
                                                        style="margin: 0px; padding: 0px;">
                                                        <i class=" fas fa-align-left"></i>
                                                    </button>
                                                    <div class="dropdown-menu" ngbDropdownMenu>
                                                        <!-- <button class="dropdown-item" (click)="trazabilidad(est)"><i
                                                                class="fas fa-copy font-14"
                                                                style="margin-right: .3rem"></i>
                                                            Trazabilidad</button> -->
                                                        <button class="dropdown-item" (click)="detalles(est)"><i
                                                                class="fas fa-copy font-14"
                                                                style="margin-right: .3rem"></i>
                                                            Detalles</button>
                                                        <!-- <button class="dropdown-item"
                                                            (click)="imprimirPlanilla(est)"><i
                                                                class="fas fa-print font-14"
                                                                style="margin-right: .3rem"></i>
                                                            Imprimir planilla</button> -->
                                                    </div>
                                                </div>

                                            </td>
                                            <td [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" class="text-center">{{est.tipo}}</td>
                                            <td [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" class="text-center">{{est.docu}}</td>
                                            <td>{{est.tipdoc}}</td>
                                            <!-- <td>{{est.abrevi}}</td> -->
                                            <td  [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" class="sorting" style="text-align: left; white-space: nowrap">
                                                <ngb-highlight [result]="est.abrevi" [term]="csearchTerm"></ngb-highlight>
                                            </td>
                                            <td  [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" class="sorting" style="text-align: left; white-space: nowrap">
                                                <ngb-highlight [result]="est.docume" [term]="csearchTerm"></ngb-highlight>
                                            </td>
                                            <!-- <td>{{est.docume}}</td> -->
                                            <td>{{est.refere01}}</td>
                                            <td>{{est.refere02}}</td>
                                            <td>{{est.ddetrac}}</td>
                                            <td  class="sorting" style="text-align: left; white-space: nowrap">
                                                <span style="display: none;">{{est.femisi | date:'yyyyMMdd'}}</span>
                                                <ngb-highlight [result]="est.femisi | date:'dd/MM/yyyy'" [term]="csearchTerm"></ngb-highlight>
                                            </td>
                                            <td  [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" class="sorting" style="text-align: left; white-space: nowrap">
                                                <span style="display: none;">{{est.fvenci | date:'yyyyMMdd'}}</span>
                                                <ngb-highlight [result]="est.fvenci | date:'dd/MM/yyyy'" [term]="csearchTerm"></ngb-highlight>
                                            </td>
                                            <!-- <td>{{est.femisi | date:'dd/MM/yyyy'}}</td>
                                            <td>{{est.fvenci | date:'dd/MM/yyyy'}}</td> -->
                                            <td>{{est.fcance | date:'dd/MM/yyyy'}}</td>
                                            <td>{{est.mora}}</td>
                                            <td style="text-align: right">{{est.tipmon}}</td>
                                            <td  class="sorting" style="text-align: right; white-space: nowrap">
                                                <ngb-highlight [result]="est.tdocumento | number:'.2-2' " [term]="csearchTerm"></ngb-highlight>
                                            </td>
                                            <td style="text-align: right">{{est.debe | number:'.2-2'}}</td>
                                            <td style="text-align: right">{{est.haber | number:'.2-2'}}</td>
                                            <td [ngClass]="{'classFechaVencimiento': (est.mora !=null && est.mora > 0)}" style="text-align: right">{{est.saldo | number:'.2-2'}}</td>
                                        
                                            <!-- <td style="text-align: right">{{est.tdocumento | number:'.2-2'}}</td> -->
                                            <td style="white-space: nowrap">{{est.planilla}}</td>
                                            <td style="white-space: nowrap">{{est.descri}}</td>
                                            <td>{{est.planletra}}</td>
                                            <td>{{est.desban}}</td>
                                            <td>{{est.numbco}}</td>
                                            <td>{{est.operac}}</td>
                                            <td>{{est.tipcam}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-template>
                    </ngb-tab>

                    <!-- 
                    <ngb-tab>
                        <ng-template ngbTabTitle> <span>Detalles</span> </ng-template>
                        <ng-template ngbTabContent>
                            <br>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped table-bordered m-t-15 table-hover"
                                    id="datatableEstadoCuentaDetalle" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <th> T.C </th>
                                            <th> Abrevi. </th>
                                            <th> Comprobante </th>
                                            <th> F.Operación </th>
                                            <th> Moneda </th>
                                            <th> Total Documento </th>
                                            <th> Amortización </th>
                                            <th> Saldo </th>
                                            <th> Planilla </th>
                                            <th> Descripción </th>
                                            <th> Banco </th>
                                            <th> #-Banco </th>
                                            <th> Cpd.Canc </th>
                                            <th> Tipo de cancelación </th>
                                            <th> Operación </th>
                                            <th> T.Cambio </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let est2 of estadocuenta2">
                                            <td>{{est2.tipdoc}}</td>
                                            <td>{{est2.abrevi}}</td>
                                            <td style="text-align: right">{{est2.docume}}</td>
                                            <td>{{est2.femisi}}</td>
                                            <td>{{est2.tipmon}}</td>
                                            <td>{{est2.debe}}</td>
                                            <td>{{est2.haber}}</td>
                                            <td>{{est2.saldocalc}}</td>
                                            <td>{{est2.planilla}}</td>
                                            <td>{{est2.descri}}</td>
                                            <td>{{est2.desban}}</td>
                                            <td>{{est2.numbco}}</td>
                                            <td>{{est2.tipcan}}</td>
                                            <td>{{est2.dtipcan}}</td>
                                            <td>{{est2.operac}}</td>
                                            <td>{{est2.tipcan}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><br>
                        </ng-template>

                    </ngb-tab>
                    -->
                    <!-- <ngb-tab>
                        <ng-template ngbTabTitle> <span>Resumen</span> </ng-template>
                        <ng-template ngbTabContent>
                            <br>

                            <div class="table-responsive">
                                <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                    <thead>
                                        <tr>
                                            <th> Tipo de comprobante </th>

                                            <th style="text-align: right;" *ngIf="camposSoles ==  true"> Soles Vencidos
                                            </th>
                                            <th style="text-align: right;" *ngIf="camposDolares ==  true"> Dólares
                                                Vencidos </th>
                                            <th style="text-align: right;" *ngIf="camposSoles ==  true"> Soles por
                                                vencer </th>

                                            <th style="text-align: right;" *ngIf="camposDolares ==  true"> Dólares por
                                                vencer </th>
                                            <th style="text-align: right;" *ngIf="camposSoles ==  true"> Total soles
                                            </th>
                                            <th style="text-align: right;" *ngIf="camposDolares ==  true"> Total dólares
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let objResumen of arrayObjResumenMonedas">
                                            <td>{{objResumen.tipodocumento}}</td>
                                            <td style="text-align: right;" *ngIf="objResumen.monedaSoles == 'PEN' ">
                                                {{objResumen.vencidosSoles | number: '.2-2'}}
                                            </td>
                                            <td style="text-align: right;" *ngIf="objResumen.monedaDolares == 'USD' ">
                                                {{objResumen.vencidosDolares | number: '.2-2'}}</td>
                                            <td style="text-align: right;" *ngIf="objResumen.monedaSoles == 'PEN' ">
                                                {{objResumen.porvencerSoles | number: '.2-2'}}
                                            </td>

                                            <td style="text-align: right;" *ngIf="objResumen.monedaDolares == 'USD' ">
                                                {{objResumen.porvencerDolares | number: '.2-2'}}</td>
                                            <td style="text-align: right;" *ngIf="objResumen.monedaSoles == 'PEN' ">
                                                {{(objResumen.vencidosSoles + objResumen.porvencerSoles) | number:
                                                '.2-2'}}
                                            </td>
                                            <td style="text-align: right;" *ngIf="objResumen.monedaDolares == 'USD' ">
                                                {{(objResumen.vencidosDolares + objResumen.porvencerDolares) | number:
                                                '.2-2' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </ng-template>
                    </ngb-tab> -->
                </ngb-tabset>

            </div>
        </div>
    </div>
</div>


<ng-template #modalImprimir let-modal>

    <div>
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Imprimir Reporte con:</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <label class="ui-checkbox ui-checkbox-inline">
                        <input type="checkbox" (change)="onChangeLetrastercero()">
                        <span class="input-span"></span>Letras de Terceros</label>

                    <br>
                    <label class="ui-checkbox ui-checkbox-inline">
                        <input type="checkbox" (change)="onChangeGarantia()">
                        <span class="input-span"></span>Garantia</label>




                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="ImprimirPDFD();" tabindex="5"><i
                        class="fa fa-save"></i> Imprimir </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelarLugarEnvio();"
                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                    Nuevo Doc.</button>
            </div>


        </div>
    </div>




</ng-template>